import type { MaquinarioStatus } from "@/services/locacoes";

export const MAQUINARIO_STATUS_THEME: Record<
  MaquinarioStatus,
  { badge: string; dot: string }
> = {
  disponivel: { badge: "bg-emerald-50 text-emerald-800 border-emerald-200", dot: "bg-emerald-500" },
  locado: { badge: "bg-sky-50 text-sky-800 border-sky-200", dot: "bg-sky-500" },
  manutencao: { badge: "bg-amber-50 text-amber-900 border-amber-200", dot: "bg-amber-500" },
  inativo: { badge: "bg-slate-100 text-slate-600 border-slate-200", dot: "bg-slate-400" },
};
